.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background-color: var(--tuna-palette-grey-400);
  color: var(--tuna-palette-background-default);
  font-size: 1.25rem;
  flex-shrink: 0;
  user-select: none;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.small {
  width: 24px;
  height: 24px;
  font-size: 0.75rem;
}

.large {
  width: 56px;
  height: 56px;
  font-size: 1.5rem;
}
